(function () {
  var form = document.getElementById('NDAccountSetupForm');
  var message = document.getElementById('NDAccountSetupMessage');
  var loading = document.getElementById('NDAccountSetupLoading');

  if (!form) return;

  var GAS_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwaBsr7bRtCpiL5DXexDJQ3kiRG9fUVkNoV0p5wQSTQ0vb0Sde1CE8jlsxMuR-kDZni/exec';

  function hideLoading() {
    if (loading) loading.style.display = 'none';
  }

  function setGateText(titleText, descText) {
    var title = document.getElementById('NDAccountGateTitle');
    var desc = document.getElementById('NDAccountGateDesc');

    if (title) title.textContent = titleText || '';
    if (desc) desc.textContent = descText || '';
  }

  function setMessage(text, isError) {
    if (!message) return;
    message.textContent = text;
    message.style.color = isError ? '#b00020' : '#1a7f37';
  }

  function getEmailFromForm() {
    var emailInput = form.querySelector('[name="customer_email"]');
    return emailInput ? String(emailInput.value || '').trim().toLowerCase() : '';
  }

  function removeExistingStatusBoxes() {
    document.querySelectorAll('.nd-account-status-box').forEach(function (el) {
      el.remove();
    });
  }

  function showForm() {
    hideLoading();
    removeExistingStatusBoxes();

    setGateText(
      'Business Account Verification',
      'Please complete your business information so our team can review and approve your access.'
    );

    if (form) form.style.display = '';
  }

  function showPendingMessage() {
    hideLoading();
    removeExistingStatusBoxes();

    setGateText(
      'Pending Approval',
      'Your business account information has already been submitted.'
    );

    form.style.display = 'none';

    var box = document.createElement('div');
    box.className = 'nd-account-status-box';
    box.style.marginTop = '24px';
    box.style.padding = '22px';
    box.style.border = '1px solid #ddd';
    box.style.background = '#f6f6f6';
    box.style.textAlign = 'center';

    box.innerHTML =
      '<h2 style="margin-top:0;">Pending Approval</h2>' +
      '<p>Your business account information has been submitted and is currently under review.</p>' +
      '<p>Please wait for administrator approval.</p>';

    form.parentNode.insertBefore(box, form.nextSibling);
  }

  function showAccessReviewCompletedMessage() {
    hideLoading();
    removeExistingStatusBoxes();

    setGateText(
      'Access Review Completed',
      'Your account information has been reviewed. Website access is pending final activation.'
    );

    form.style.display = 'none';

    var box = document.createElement('div');
    box.className = 'nd-account-status-box';
    box.style.marginTop = '24px';
    box.style.padding = '22px';
    box.style.border = '1px solid #ddd';
    box.style.background = '#f6f6f6';
    box.style.textAlign = 'center';

    box.innerHTML =
      '<h2 style="margin-top:0;">Access Review Completed</h2>' +
      '<p>Your account information has been reviewed.</p>' +
      '<p>Website access is pending final activation by our team.</p>' +
      '<p style="margin-top:18px;">If your access was recently activated, please click the button below to check again.</p>' +
      '<p><a class="button" href="/?nd_account_check=1&nd_ts=' + Date.now() + '">Check Access Again</a></p>';

    form.parentNode.insertBefore(box, form.nextSibling);
  }

  function markSubmitted(email) {
    if (!email) return;
    try {
      localStorage.setItem('nd_account_verification_submitted', '1');
      localStorage.setItem('nd_account_verification_email', email);
    } catch (e) {}
  }

  function clearSubmittedFlag() {
    try {
      localStorage.removeItem('nd_account_verification_submitted');
      localStorage.removeItem('nd_account_verification_email');
    } catch (e) {}
  }

  function isLocallySubmitted(email) {
    try {
      var submitted = localStorage.getItem('nd_account_verification_submitted') === '1';
      var savedEmail = String(localStorage.getItem('nd_account_verification_email') || '').trim().toLowerCase();
      return submitted && email && savedEmail === email;
    } catch (e) {
      return false;
    }
  }

  function isReviewedStatus(status) {
    return (
      status === 'approved' ||
      status === 'reviewed' ||
      status === 'review-completed'
    );
  }

  function checkSheetStatus(email) {
    if (!email) {
      showForm();
      return;
    }

    fetch(GAS_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
      body: JSON.stringify({
        action: 'check_status',
        customer_email: email
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ok) {
          if (isLocallySubmitted(email)) {
            showPendingMessage();
          } else {
            showForm();
          }
          return;
        }

        var status = String(data.status || '').trim().toLowerCase();

        if (data.submitted && isReviewedStatus(status)) {
          clearSubmittedFlag();
          showAccessReviewCompletedMessage();
          return;
        }

        if (data.submitted && (status === 'pending-review' || status === 'pending')) {
          markSubmitted(email);
          showPendingMessage();
          return;
        }

        if (isLocallySubmitted(email)) {
          showPendingMessage();
          return;
        }

        showForm();
      })
      .catch(function (err) {
        console.warn('[ND Account Setup] status check failed:', err);

        if (isLocallySubmitted(email)) {
          showPendingMessage();
        } else {
          showForm();
        }
      });
  }

  var initialEmail = getEmailFromForm();

  if (initialEmail) {
    if (isLocallySubmitted(initialEmail)) {
      showPendingMessage();
    }

    checkSheetStatus(initialEmail);
  } else {
    setTimeout(function () {
      var emailAfterDelay = getEmailFromForm();

      if (emailAfterDelay) {
        checkSheetStatus(emailAfterDelay);
      } else {
        showForm();
      }
    }, 700);
  }

  var emailInput = form.querySelector('[name="customer_email"]');

  if (emailInput) {
    emailInput.addEventListener('blur', function () {
      var email = getEmailFromForm();
      if (email) {
        checkSheetStatus(email);
      }
    });

    emailInput.addEventListener('change', function () {
      var email = getEmailFromForm();
      if (email) {
        checkSheetStatus(email);
      }
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    var formData = new FormData(form);
    var payload = {};

    formData.forEach(function (value, key) {
      payload[key] = value;
    });

    if (payload.hp) {
      setMessage('Submission blocked.', true);
      return;
    }

    fetch(GAS_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ok) {
          throw new Error(data && data.message ? data.message : 'Submission failed.');
        }

        var email = getEmailFromForm();
        markSubmitted(email);

        setMessage('Your information has been submitted. Your account is pending approval.', false);

        setTimeout(function () {
          showPendingMessage();
        }, 800);
      })
      .catch(function (err) {
        console.error('[ND Account Setup] Error:', err);
        setMessage('Unable to submit your information. Please try again or contact us.', true);

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit for Review';
        }
      });
  });
})();